import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { generatePath, Link } from 'react-router-dom';

import Routes from 'config/routes';
import { RingNeighborDto } from 'generated/apiSchemas';

interface RingNavigationButtonProps {
  ring: RingNeighborDto | null;
  direction: 'previous' | 'next';
  backTo: string;
}

export const RingNavigationButton = ({
  ring,
  direction,
  backTo,
}: RingNavigationButtonProps) => {
  const icon = direction === 'previous' ? <LeftOutlined /> : <RightOutlined />;
  const buttonProps = {
    type: 'primary',
    icon,
  } as const;

  if (!ring) {
    return <Button {...buttonProps} disabled />;
  }

  return (
    <Link
      to={generatePath(Routes.QualityRingComplianceReportDetail, {
        ringId: ring.id,
      })}
      state={{ backTo }}
    >
      <Button {...buttonProps} />
    </Link>
  );
};
